export default "__VITE_ASSET__BLJUwc2n__"